
import { ReactNode } from "react";

interface BlogContentProps {
  children: ReactNode;
}

export const BlogContent = ({ children }: BlogContentProps) => {
  return <div className="text-lg text-gray-800 leading-relaxed">{children}</div>;
};

export const BlogParagraph = ({ children }: BlogContentProps) => {
  return <p className="text-lg text-gray-800 leading-relaxed mb-4">{children}</p>;
};

export const BlogHeading = ({ children }: BlogContentProps) => {
  return <h4 className="text-lg font-semibold text-gray-800 mt-5 mb-2">{children}</h4>;
};

export const BlogEmphasis = ({ children }: BlogContentProps) => {
  return <p className="text-lg font-semibold text-gray-800 mb-4">{children}</p>;
};

interface BlogQuizQuestionProps {
  question: string;
  options: string[];
  answer: string;
  explanation: string;
}

export const BlogQuizQuestion = ({ question, options, answer, explanation }: BlogQuizQuestionProps) => {
  const getOptionLetter = (index: number) => {
    return String.fromCharCode(65 + index);
  };

  return (
    <div className="mb-6 p-4 bg-gray-50 rounded-lg">
      <h4 className="font-medium text-gray-800 mb-3">{question}</h4>
      <ul className="space-y-2 mb-4">
        {options.map((option, index) => {
          const isCorrect = option.startsWith(answer + ".");
          return (
            <li 
              key={index} 
              className={`p-2 rounded-md ${isCorrect ? 'bg-green-100 border-l-4 border-green-500' : ''}`}
            >
              {option}
              {isCorrect && <span className="ml-2 text-green-600 font-semibold">✓</span>}
            </li>
          );
        })}
      </ul>
      <div className="mt-2 pt-2 border-t border-gray-200">
        <p className="text-sm text-gray-700 italic">
          <span className="font-semibold">Pour en savoir plus :</span> {explanation}
        </p>
      </div>
    </div>
  );
};
